
import { Component, Vue } from 'vue-property-decorator'

import authModule from '@/store/auth'
import listModule from '@/store/list'
import whitelabelModule from '@/store/whitelabel'

import AdminEditor from '@/components/whitelabel/admin/AdminEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'AdminList',
  components: {
    AdminEditor,
    ContentList
  }
})
class AdminList extends Vue {
  private listType = ListType

  private get storeModule() {
    return whitelabelModule
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
      ? whitelabelModule.whitelabel._id
      : authModule.user!.whitelabel._id!
  }

  private get admins() {
    return whitelabelModule.admins
  }

  private get headers() {
    return [
      { text: 'Email', value: 'email' },
      { text: 'Vorname', value: 'firstName' },
      { text: 'Nachname', value: 'lastName' },
      { text: 'Entfernen', value: 'actionDelete', sortable: false }
    ]
  }

  private async deleteAdmin(admin: any) {
    await whitelabelModule.deleteAdmin({
      whitelabel: this.whitelabel,
      userId: admin._id
    })

    whitelabelModule.fetchAllAdmins({
      limit: listModule.perPage
    })
  }
}

export default AdminList
